export enum LoginScreenEnum {
  login = 'login',
  otp = 'otp',
}
